<template>
	<div class="wrapper">
		<!-- <el-row :gutter="24"> -->
		<!-- <el-col :span="24"> -->
		<!-- <el-card shadow="always"> -->
		<div class="wrapper_head">
			<div class="meeting-search-text">
				用户列表
			</div>
		</div>
		<div class="" style="margin-left: 7px;">
			<el-form :inline="true" :model="adminForm" class="demo-form-inline wrapper_head_input">
				<div class="flex align-center justify-between" style="width: 94.6%;">
					<div class="flex align-center">
						<el-form-item style="width: 300px;" label="姓名">
							<el-input v-model="adminForm.name" placeholder="请输入姓名" clearable></el-input>
						</el-form-item>
						<el-form-item style="width: 300px;" label="证件号码">
							<el-input v-model="adminForm.username" placeholder="请输入证件号码" clearable></el-input>
						</el-form-item>
						<el-form-item style="width: 300px;" label="状态">
							<el-select v-model="adminForm.ban" placeholder="请选择状态">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item style="margin-right: 5px;">
							<!-- style="background:#de4d2a !important" -->
							<el-button icon="el-icon-search" type="primary" @click="onSearch">查询</el-button>
						</el-form-item>
						<el-form-item class="">
							<el-button style="background-color: #F2F3F7;" icon="el-icon-zhongzhishaixuan"
								:style="resetStyle()" :disabled="resetDisabled" @click="reset()">重置</el-button>
						</el-form-item>
						
					</div>
					<!-- <div class="flex align-center justify-end">
						
					</div> -->
				</div>
			</el-form>
		</div>
		<!-- </el-card> -->
		<!-- </el-col> -->
		<!-- </el-row> -->
		<!-- <el-row class="table-meeing"> -->
		<el-table :data="tableData" size="medium" height="72vh" v-loading="tableLoading"
			@selection-change="handleSelectionChange">
			<el-table-column type="selection" min-width="50" align="center"> </el-table-column>
			<el-table-column prop="num" label="序号" min-width="50px" align="center"></el-table-column>
			<el-table-column min-width="250" label="姓名/企业名" prop="name" align="center"></el-table-column>
			<el-table-column min-width="200" prop="certificateType" label="证件类型" align="center">
				<template slot-scope="scope">
					{{ scope.row.certificateType === 'COMPANY' ? '企业社会统一信用代码' : '中华人民共和国居民身份证' }}
				</template>
			</el-table-column>
			<el-table-column min-width="250" prop="idNumber" label="证件号码/企业社会统一信用编码" align="center">
				<template slot-scope="scope">
					{{ scope.row.idNumber == null ? '无' : scope.row.idNumber}}
				</template>
			</el-table-column>
			<el-table-column min-width="250" prop="username" label="账号" align="center"> </el-table-column>
			<el-table-column min-width="150" prop="cypher" label="密码" align="center"> </el-table-column>
			<el-table-column min-width="150" prop="phone" label="手机号码" align="center"> </el-table-column>
			<el-table-column min-width="100" prop="ban" label="状态" align="center">
				<template slot-scope="scope">
					<div class="flex align-center justify-center">
						<div class="flex align-center">
							<div class="" style="margin-right: 8px;width: 6px;height: 6px;border-radius: 50%;"
								:style="scope.row.ban?'background-color: #FF5733;':'background-color: #00C800;'">

							</div>
							<div class="">
								{{ scope.row.ban ? '已停用' : '启用中' }}
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column min-width="200" label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="medium" type="text" style="color:#2766FF;"
						@click="editUser(scope.row, 'creditor','')">编辑</el-button>
					<!-- <el-button size="medium" icon="el-icon-delete " type="text" style="color:#2766FF;"
						@click="deleteUser(scope.row.id)"></el-button> -->
						<el-tooltip  class="item" effect="dark" content="删除" placement="top">
							<div class="el-icon-delete" style="font-size: 16px;color: #2766FF;margin-right: 10px;"
								@click="deleteUser(scope.row.id)">
						
							</div>
							
						</el-tooltip>
						<el-tooltip v-if="scope.row.ban" class="item" effect="dark" content="启用" placement="top">
							<div class="el-icon-kaishi" style="font-size: 16px;color: #2766FF;margin-right: 10px;"
								@click="enableoroutManager(false, scope.row.id)">
						
							</div>
						</el-tooltip>
						<el-tooltip v-else class="item" effect="dark" content="停用" placement="top">
							<div class="el-icon-tingyong_line" style="font-size: 16px;color: #2766FF;margin-right: 10px;"
								@click="enableoroutManager(true, scope.row.id)">
						
							</div>
						</el-tooltip>
						
					<!-- <el-button size="medium" icon="el-icon-kaishi" type="text" style="color:#2766FF;font-size: 16px;"
						v-if="scope.row.ban" @click="enableoroutManager(false, scope.row.id)"></el-button>
					<el-button size="medium" icon="el-icon-tingyong_line" type="text"
						style="color:#2766FF;font-size: 16px;" v-else @click="enableoroutManager(true, scope.row.id)">
					</el-button> -->
					<!-- <el-button size="mini" type="text" style="color:#2766FF;">重置密码</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<Pagination :total="total" @handleSizeChange="turnPage" @handleCurrentChange="turnPage">
			<template v-slot:operation>
				<div>
					<el-button style="border-color: #2766FF;color: #2766FF;" @click="batchEable(false)">批量启用
					</el-button>
					<el-button style="border-color: #2766FF;color: #2766FF;" @click="batchEable(true)">批量停用
					</el-button>
				</div>
			</template>
		</Pagination>
		<!-- </el-row> -->
		<!-- 编辑债权人 -->
		<CreditorDialog :creditorDialogVisible="creditorDialogVisible" :creditorForm="editUserForm" :isShow="false"
			:isEdit="isEdit" :userId="userId" @cancel="cancelVisible" @refreshList="getUserList" />
	</div>
</template>

<script>
	import logicList from '@/mixins/logicList';
	export default {
		mixins: [logicList],
		data() {
			return {
				adminForm: {
					name: '',
					page: 0,
					rows: 20,
					ban: '',
					type: 'CREDITOR',
					username: ''
				}
			};
		}
	};
</script>
<style scoped lang="scss">
	@import './scss/index.scss';
</style>
